import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import BellIconOutline from 'mdi-react/BellOutlineIcon';
import BellIcon from 'mdi-react/BellIcon';
import { AppContext } from 'src/components/app-context';
import {
  createAlertRequest as createAlertRequestAction,
  removeAlertRequest as removeAlertRequestAction,
} from '../../../../areas/sidebar/actions/alert';
import * as S from './styles';

const AlertButton = props => {
  const { linkTo } = useContext(AppContext);
  const {
    product,
    account,
    userProductAlerts,
    createAlertRequest,
    removeAlertRequest,
    text,
    type,
    history,
  } = props;
  const { isAuthenticated } = account || {};
  const userAlert = userProductAlerts.find(
    alert => alert.productId === product.id
  );
  const alertId = userAlert && userAlert.alertId;

  return (
    <S.AlertButton>
      <button
        type="button"
        onClick={() => {
          if (isAuthenticated) {
            if (!alertId) {
              createAlertRequest({
                productId: product.id,
                type,
              });
            } else {
              removeAlertRequest(alertId, product.id);
            }
          } else {
            history.push(linkTo('productAlert', product));
          }
        }}
      >
        {alertId ? <BellIcon height={20} /> : <BellIconOutline height={20} />}
        {text}
      </button>
    </S.AlertButton>
  );
};

AlertButton.propTypes = {
  userProductAlerts: PropTypes.arrayOf(
    PropTypes.shape({ productId: PropTypes.number, alertId: PropTypes.number })
  ),
  account: PropTypes.shape({
    isAuthenticated: PropTypes.bool,
  }),
  product: PropTypes.shape({
    alert: PropTypes.shape({
      id: PropTypes.number,
    }),
    id: PropTypes.number,
    pathName: PropTypes.string,
  }),
  createAlertRequest: PropTypes.func.isRequired,
  removeAlertRequest: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.string,
  history: PropTypes.object.isRequired,
};

AlertButton.defaultProps = {
  account: {
    isAuthenticated: false,
  },
  userProductAlerts: [],
  product: {},
  type: 'IN_STOCK',
};

const dispatchActions = {
  createAlertRequest: createAlertRequestAction,
  removeAlertRequest: removeAlertRequestAction,
};

export default connect(
  state => ({
    account: state.areas.account,
    userProductAlerts: state.areas.sidebar.alerts.products,
  }),
  dispatchActions
)(memo(withRouter(AlertButton)));
